import React from "react";
import MUIDataTable from "../../components/MUIGrid";

const UserBacklinkTypeModal = ({ modalState }) => {
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 100,
    page: 1,
  });
  const columns = [
    { field: "counter", headerName: "Sr#", width: 10 },
    {
      field: "backlink_type",
      headerName: "Backlink Type",
      width: 250,
    },
    {
      field: "total_tasks",
      headerName: "Total Tasks",
      width: 200,
    },
  ];
  const handlePageSizeChange = (newPageSize) => {
    setPaginationModel({ ...paginationModel, pageSize: newPageSize });
  };
  const handlePageChange = (params) => {
    setPaginationModel({ pageSize: params.pageSize, page: params.page + 1 });
  };

  return (
    <MUIDataTable
      columnDefs={columns}
      items={(modalState?.data?.length ? modalState?.data : [])?.map(
        (record, index) => {
          const { backlink_type, total_tasks } = record;
          return {
            counter: index + 1,
            backlink_type,
            total_tasks,
          };
        }
      )}
      totalItems={modalState?.data?.length}
      height="60vh"
      pagination="No"
      paginationModel={paginationModel}
      searchable="No"
      showCount="No"
      sortingMode="client"
      paginationMode="client"
      toolbar="No"
      onPaginationModelChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}
    />
  );
};

export default UserBacklinkTypeModal;
